import * as React from 'react';
import { Button, Provider, teamsTheme, Text, Image, Layout, Flex, Segment, Loader, Card, CardHeader, CardBody, Header, Input, SearchIcon, CardFooter, OpenOutsideIcon, Tooltip, Dialog, LinkIcon, ArrowRightIcon, List, MegaphoneIcon, Label, InfoIcon, ParticipantAddIcon, AttendeeIcon, TenantPersonalIcon, Checkbox, TeamsMonochromeIcon, Grid, CloseIcon, WorkOrSchoolIcon, SettingsIcon, Divider, ArrowLeftIcon } from '@fluentui/react-northstar';
import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { RequestHeaders } from '../helpers/HttpRequest';

class SettingsComponent extends React.Component<ISettingsProps, ISettingsState> {
    fromHome: boolean;
    constructor(props) {        
        super(props);        
        this.state = {
            isLoading: true, loaderLabel: '', openDialog: false, preferencesStatus: [{}]
        };        
        this.fromHome = Helpers.getUrlPar("fromHome") === "true";
        this.handlePreferencesChanged = this.handlePreferencesChanged.bind(this);
    }
    componentDidMount() {        
        this.getUserPreferences();
    }
    getUserPreferences() {
        let url = "/setup/getPreferencesStatus";
        var self = this;
        axios.get(url)
            .then(response => {
                var data = response.data;
                if (data != null) {
                    var preferences = [];
                    for (const [key, value] of Object.entries(data)) {
                        preferences.push({ type: key, value: value, loading: false } )
                    }
                    this.setState({ isLoading: false, preferencesStatus: preferences });
                }
            })
            .catch(function (error) {
                self.setState({ isLoading: true, preferencesStatus:[] });
            });
    }
    handlePreferencesChanged(props, index, key) {
        var preferences = this.state.preferencesStatus;
        preferences[index].loading = true;
        this.setState({ preferencesStatus: preferences });
        switch (key) {
            case 'archiveFiles':
                {
                }; break;
        }
        var url = '/Setup/UpdatePreferencesStatus';
        let config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        }
        let params = new URLSearchParams();
        params.append('key', key);
        params.append('value', String(props.checked));
        axios.post(url, params, config).then((resp) => {
            var preferences = this.state.preferencesStatus;
            preferences[index].loading = (resp.data.code != 'Success');
            preferences[index].value = !preferences[index].value;
            if(resp.data.code != 'Success'){
                preferences[index].error = 'Access Denied, please contact your admin to grant permissions for this action.';
            }
            this.setState({ preferencesStatus: preferences });            
        });        
    }
    render() {
        const preferences = [{
            type: 'archiveFiles',
            content: 'Archive channel files upon channel automatic deletion'
        }];
        return (
            <Flex column gap='gap.medium' styles={{width: '100%'}}>
                {this.fromHome && <Button icon={<ArrowLeftIcon/>} iconOnly onClick={() => {
                    window.location.href = '/base';
                }} style={{width: '40px'}}/>}
                <Segment color='brand'
                    content={
                        <Flex column hAlign='center' vAlign='center' gap='gap.medium'>                            
                             <Flex inline={!this.props.isMobile} column={this.props.isMobile} hAlign={this.props.isMobile ? 'center' : 'start'} vAlign={this.props.isMobile ? 'center' : 'start'} gap='gap.medium' styles={{ width: '100%' }}>
                                <div style={{ position: 'relative', width: '100%' }}>                                    
                                    <Flex inline hAlign='start' vAlign='start' gap='gap.medium' styles={{ width: '100%', marginTop: this.props.isMobile? '20px' : '0px' }}>
                                        <WorkOrSchoolIcon size='larger' styles={({ theme: { siteVariables } }) => ({
                                            color: siteVariables?.colorScheme?.brand?.foreground,
                                        })} />
                                        <Header content='Personal Information' styles={{ marginTop: this.props.isMobile? '5px' : '-5px' }} />
                                    </Flex>
                                    <div style={{position: 'absolute', right: '0px', top: '0px'}}>
                                        <Flex.Item>
                                            <Button secondary icon={<OpenOutsideIcon />} text content='Open DashBoard' onClick={
                                                (e) => {
                                                    e.preventDefault();
                                                    window.open(new RequestHeaders().url);
                                                }
                                            } title={`Open in ${Helpers.getAppName()}`} />
                                        </Flex.Item>
                                    </div>
                                </div>
                             </Flex>
                            <Flex inline={!this.props.isMobile} column={this.props.isMobile} hAlign='center' vAlign='center'>
                                <Flex inline>
                                    <Image src={this.props.userInfo.image} alt='profile' styles={{ width: '100px', height: '100px', marginTop: this.props.isMobile? '-15px' : '0px' }} circular />
                                    {this.props.isMobile ? <div /> :
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                height: '80%',
                                                alignItems: 'center',
                                                marginLeft: '50px'
                                            }}
                                        >
                                            <Divider vertical />
                                        </div>}
                                </Flex>
                                <Flex column vAlign='center' gap='gap.medium'>
                                    <Flex inline={!this.props.isMobile} column={this.props.isMobile} hAlign='start' vAlign='start' gap='gap.medium'>
                                        <Text content='Name:' />
                                        <Text weight='semibold' content={this.props.userInfo.name} />
                                    </Flex>
                                    <Flex inline={!this.props.isMobile} column={this.props.isMobile} hAlign='start' vAlign='start' gap='gap.medium'>
                                        <Text content='Url instance:' />
                                        <Text weight='semibold' content={new RequestHeaders().url} />
                                    </Flex>
                                </Flex>
                        </Flex>
                    </Flex>}
                />
                <Segment color='brand'
                    content={<Grid columns='repeat(4, 1fr)' rows={'50px ' + this.state.preferencesStatus.length*50 + 'px'}>
                        <Flex inline gap='gap.medium' styles={{ gridColumn: 'span 4' }}>
                            <SettingsIcon size='larger' styles={({ theme: { siteVariables } }) => ({
                                color: siteVariables?.colorScheme?.brand?.foreground,
                            })} />
                            <Header content='Preferences' styles={{ marginTop: '-5px' }} />
                        </Flex>
                        <Flex column hAlign='start' vAlign='start' styles={{ gridColumn: 'span 4' }}>
                            {   this.state.preferencesStatus.length > 0?
                                this.state.preferencesStatus.map((item, index) => {
                                    return <Checkbox disabled={item.loading}
                                        key={Math.floor(Math.random() * 1000000000)}
                                        label={<span>{preferences[index].content}.&nbsp;{item.error && <Text content={item.error} color='red'/>}</span>}
                                        checked={item.value}                                        
                                        onChange={(e, props) => { this.handlePreferencesChanged(props, index, item.type) }}
                                        styles={{ marginLeft: '20px' }} />;
                            }):<div/>}
                        </Flex>
                        
                    </Grid>}
                />
                <Text style={{textAlign: 'center'}} content={'V.' + Helpers.getAddonVersion()}/>
            </Flex>
            );
    }
}
export default SettingsComponent;
interface ISettingsState {
    isLoading: boolean;
    loaderLabel: string;
    openDialog: boolean;
    preferencesStatus: any;
}
interface ISettingsProps {    
    redirectPage: string;
    executeDeepLink(link);
    isMobile: boolean;
    userInfo: any
}